import { create } from 'zustand';
import api from 'core/api';
import { toastr } from 'react-redux-toastr';
import {
  SEND_PROPOSALS_URL_RUBI_YIELD,
  SEND_PROPOSALS_URL,
} from 'utils/api';

export const buildPayloadRequest = ({ operationId, clients }) => ({
  operacaoId: operationId,
  propostas: clients.map(client => ({
    cliente: client.clienteId,
    quantidade: client.quantity,
    operacaoId: operationId,
  })),
});

export const buildRubiYieldPayloarRequest = ({ clients }) => ({
  listaDetalhesOperacao: clients.map(client => ({
    codigoCliente: client.clienteId,
    quantidade: client.quantity,
  })),
});

const useProposal = create(
  (set, get) => ({
    currentProposal: {},
    setCurrentProposal: (value) => {
      set(state => ({
        ...state,
        currentProposal: { ...value },
      }));
    },
    response: {
      mensagens: [],
    },
    proposal: false,
    loading: false,
    error: false,
    errors: [],

    isSendingPush: false,
    setIsSendingPush: (value) => {
      set(state => ({
        ...state,
        isSendingPush: value,
      }));
    },
    clearSentProposal: () => {
      set(state => ({
        ...state,
        proposal: false,
        error: false,
        errors: [],
      }));
    },
    sendProposals: (payload) => {
      get().setIsSendingPush(false);

      const { isNewOperation } = payload;
      const ROUTE = isNewOperation
        ? SEND_PROPOSALS_URL_RUBI_YIELD.replace('{tradeIdeaId}', payload.operationId)
        : SEND_PROPOSALS_URL;

      api.post(
        ROUTE,
        !isNewOperation ? buildPayloadRequest(payload) : buildRubiYieldPayloarRequest(payload),
      )
        .then((response) => {
          const { propostas, mensagens } = response.data;
          if (isNewOperation) {
            if (response.status !== 200) {
              /* const msgError = response.data.erros.length > 0
                    ? response.data.erros.map(msg => (msg.descricao)).join(' ')
                    : 'Tente novamente mais tarde'; */

              toastr.error('Ocorreu um erro ao enviar a proposta. Tente novamente mais tarde');
              set(state => ({ ...state,
                loading: false,
                error: true,
              }));
            } else {
              const res = {
                ...response.data,
                mensagens: response.data.erros || [],
              };
              set(state => ({
                ...state,
                proposal: true,
                loading: false,
                response: res,
              }));
            }
          } else if (response.data.error || propostas.length === 0) {
            const msgError = mensagens.length > 0
              ? mensagens.map(msg => (msg.descricao)).join(' ')
              : 'Tente novamente mais tarde';

            toastr.error('Erro ao enviar proposta', msgError);
            set(state => ({ ...state,
              loading: false,
              error: true,
            }));
          } else {
            set(state => ({
              ...state,
              proposal: true,
              loading: false,
              response: response.data,
            }));
          }
        }).catch((e) => {
          console.log('error', e.response.data);
          toastr.error('Ocorreu um erro ao enviar a proposta. Tente novamente mais tarde');
          set(state => ({ ...state,
            loading: false,
            error: true,
            errors: e.response.data.erros,
          }));
        });
    },
  }),
);

export default useProposal;
